import { costSummary, taxRatePercentLabel, type CostingLineItemLike } from "./costing";
import { formatPriceCents } from "../../lib/money";
import styles from "./CostSummary.module.css";

export interface CostSummaryProps {
  /** Line items to total; every subtotal is derived, never stored. */
  items: readonly CostingLineItemLike[];
  /** Tax rate in basis points (1000 = 10% GST). */
  taxRateBps: number;
}

/**
 * Subtotal / GST / Total block for the Scope page. All values are
 * derived from the items on every render, so any quantity, amount, or tax-rate
 * change is reflected immediately. Reusable wherever line items are totalled.
 */
export function CostSummary({ items, taxRateBps }: CostSummaryProps) {
  const { subtotalCents, taxCents, totalCents } = costSummary(items, taxRateBps);

  return (
    <dl className={styles.root}>
      <div className={styles.row}>
        <dt className={styles.label}>Subtotal</dt>
        <dd className={styles.value}>{formatPriceCents(subtotalCents)}</dd>
      </div>
      <div className={styles.row}>
        <dt className={styles.label}>GST ({taxRatePercentLabel(taxRateBps)})</dt>
        <dd className={styles.value}>{formatPriceCents(taxCents)}</dd>
      </div>
      <div className={`${styles.row} ${styles.total}`}>
        <dt className={styles.totalLabel}>Total</dt>
        <dd className={styles.totalValue}>{formatPriceCents(totalCents)}</dd>
      </div>
    </dl>
  );
}
